import React from 'react'
import { APPROVAL_COMMON_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

export default function ViewComments({ comments = [] }) {
  const {t}=useTranslation()
  return (
    <>
      {comments.map((option, index) => (
        <div key={index} className='approval-card' style={{ backgroundColor: '#fff' }}>
          <div className='approval-card-header row'>
            <span className='col-8'>
              <span>{t(APPROVAL_COMMON_KEYS.AUTHORIZER)} : {option.authorizer}</span>
              <span>{t(APPROVAL_COMMON_KEYS.COMMENTS)} : {option.authorizerComments}</span>
            </span>
            <span className='col-4'>
              <span className="text-right">{t(APPROVAL_COMMON_KEYS.AUTH_LEVEL)} : {option.authLevel}</span>
              <span className='span2 text-right'>
                {option?.authDate !== null
                  ? option?.authDate
                  : '-'}
              </span>
            </span>
          </div>
        </div>
      ))}
    </>
  )
}
